export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/v97192967d80e74067130c16800aa146e09aa027c-runtime-main.e34b9f95ca63ce1b0686.worker.js");
}
